import { v4 as uuidv4 } from 'uuid'

const PREVIOUS = 'PREVIOUS'
const NEXT = 'NEXT'

const IDLE_MODE = 'IDLE'
const EDIT_MODE = 'EDIT'

const WARM_UP_PAGE = 'warmup'
const COOL_DOWN_PAGE = 'cooldown'

const DELETED = 'DELETED'
const FETCHED = 'FETCHED'
const INSERTED = 'INSERTED'

export const COMPETENCIES_FIELD = 'COMPETENCIES_FIELD'

export const INSERTED_CATEGORY = 'INSERTED'

export const CATEGORY_PLACEMENT = { [NEXT]: NEXT, [PREVIOUS]: PREVIOUS }
export const MODES = { [IDLE_MODE]: IDLE_MODE, [EDIT_MODE]: EDIT_MODE }
export const QUESTION_STATUSES = {
  [DELETED]: DELETED,
  [FETCHED]: FETCHED,
  [INSERTED]: INSERTED,
}
export const STATIC_PAGES = [WARM_UP_PAGE, COOL_DOWN_PAGE]

export const CATEGORY_TITLE_FIELD = 'title'
export const DESCRIPTION_FIELD = 'description'
export const QUESTIONS_GROUP_FIELD = 'questions'
export const QUESTION_FIELD = 'question'
export const SCOREABLE_FIELD = 'scoreable'

export const getDefaultValues = () => ({
  [CATEGORY_TITLE_FIELD]: '',
  [QUESTIONS_GROUP_FIELD]: [],
  [SCOREABLE_FIELD]: true,
})

export const getValues = ({ questions, scoreable, title }) => ({
  title,
  questions: questions.map(({ description, id, status, title }) => ({
    description,
    question: title,
    status: status ?? QUESTION_STATUSES.FETCHED,
    uuid: id,
  })),
  scoreable,
})

export const getNewCategory = () => ({
  id: uuidv4(),
  description: '',
  key: INSERTED_CATEGORY,
  title: '',
  questions: [],
  scoreable: true,
})
